import { render, staticRenderFns } from "./estate-mobile-contact.vue?vue&type=template&id=24aa4612&scoped=true&"
import script from "./estate-mobile-contact.vue?vue&type=script&lang=js&"
export * from "./estate-mobile-contact.vue?vue&type=script&lang=js&"
import style0 from "./estate-mobile-contact.vue?vue&type=style&index=0&id=24aa4612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa4612",
  null
  
)

export default component.exports